//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { myAffSp } from "@/api/bpmnApi/bpmn";
export default {
  name: "batchModel",
  components: {},
  props: {
    leaData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      resultData: {
        approvalType: "",
        instIds: "",
        opinion: ""
      }
    };
  },
  computed: {},
  methods: {
    // 确定提交
    submitForm: function submitForm() {
      var _this = this;

      myAffSp(this.resultData).then(function (res) {
        if (res.data.code == "0") {
          _this.$message.success("操作成功!");

          _this.leaData.show = false;

          _this.$emit("close");
        } else {
          _this.$message.warning(res.data.msg);
        }
      }).catch(function (err) {
        _this.$message.error("服务器异常!");
      });
    }
  },
  watch: {
    "leaData.show": {
      handler: function handler(val) {
        if (val) {
          this.resultData = {
            approvalType: this.leaData.type,
            taskIds: this.leaData.taskIds,
            opinion: ""
          };
        }
      }
    },
    deep: true
  }
};